import React from 'react';
import { InfoTip } from '../common/InfoTip';

interface ReciprocityBadgeProps {
  reciprocal: boolean | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Apr-17 Phase 2b: small pill indicating whether this match is Primary
 * (direct value exchange) or Adjacent (SOFT-fallback backfill — cosine-
 * relevant but not a reciprocal primary_goal match).
 *
 * Returns null for null/undefined (legacy matches, pre-reciprocity feature).
 */
const ReciprocityBadge: React.FC<ReciprocityBadgeProps> = ({
  reciprocal,
  size = 'sm',
  className = '',
}) => {
  if (reciprocal == null) return null;

  const sizeClasses = size === 'sm'
    ? 'text-[0.65rem] px-1.5 py-0.5'
    : 'text-xs px-2 py-0.5';

  if (reciprocal) {
    return (
      <InfoTip tooltipKey='reciprocity-tier'>
        <span
          data-tour-id='match-tier-pill'
          className={`inline-flex items-center gap-1 rounded-full font-semibold border ${sizeClasses} bg-green-50 text-green-700 border-green-200 ${className}`}
        >
          <span aria-hidden>⊕</span>
          Primary
        </span>
      </InfoTip>
    );
  }

  return (
    <InfoTip tooltipKey='reciprocity-tier'>
      <span
        data-tour-id='match-tier-pill'
        className={`inline-flex items-center gap-1 rounded-full font-semibold border ${sizeClasses} bg-gray-50 text-body-500 border-gray-200 ${className}`}
      >
        <span aria-hidden>○</span>
        Adjacent
      </span>
    </InfoTip>
  );
};

export default ReciprocityBadge;
